<template lang="pug">
  section.intro
    h1.transition.show1(:class="{showed: config.bg}") ¿Cuánto sabes de <br>
      span  Fórmula E?
    router-link.transition.show3.btn-start(to="/trivia", :class="{showed: config.bg}") Empezar
    img.transition.formulae-logo-y-frases.show2(src="https://www.latercera.com/wp-content/uploads/2019/01/ABB_Logo.png", alt="Fórmula E", :class="{showed: config.bg}")
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  export default {
    computed: {
      ...mapState([
      'config'
    ])
    },
    methods: {
      ...mapActions([
        'setBg'
      ])
    }
  }
</script>

<style scoped lang="scss">

.intro{
  min-height: calc(100vh - 124px);
  text-align: center;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
}
.transition{
  opacity: 0;
  transition: opacity 0.5s;
  &.showed{
    opacity: 1;
  }
}
.show1{
  transition-delay: 0.5s;
}
.show2{
  transition-delay: 1s;
}
.show3{
  transition-delay: 1.5s;
}

h1{
  font-size: 5.25rem;
  font-family: 'Raleway', sans-serif;
  text-transform: uppercase;
  br{
    display: none;
    @media (min-width: 1200px){
      display: block;
    }
  }
  span{
    position: relative;
    &:after{
      content: '';
      border-bottom: 10px solid white;
      position: absolute;
      bottom: -10px;
      left: 0;
      right: 0;
    }
  }
  padding-bottom: 2rem;
}
.btn-start{
  display: block;
  border: 2px solid white;
  color: white;
  font-family: 'Oswald', sans-serif;
  text-transform: uppercase;
  font-weight: 700;
  text-size-adjust: 100%;
  font-size: 4rem;
  padding: 1rem 2rem;
  margin-left: auto;
  margin-right: auto;
  &:hover{
    background-color: white;
    color: cornflowerblue;
  }
}
.formulae-logo-y-frases{
  max-height: 100px;
  max-width: 90%;
}
</style>
